<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/responseLibrary' }">应对库</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div>
          <el-form ref="formData" :model="formData" label-width="80px">
            <el-form-item label="一级分类">
              <el-col :span="5">
                <el-cascader
                  v-model="formData.one_cate_id"
                  placeholder="选择一级分类"
                  :options="topClass"
                  filterable
                  clearable
                ></el-cascader>
              </el-col>
              <el-col :span="5">
                <el-button type="primary" @click="popout = true">新建分类</el-button>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple"></div>
              </el-col>
            </el-form-item>

            <el-form-item label="二级分类">
              <el-col :span="5">
                <el-cascader
                  v-model="formData.two_cate_id"
                  placeholder="选择二级分类"
                  :options="secondaryClass"
                  filterable
                  clearable
                ></el-cascader>
              </el-col>
              <el-col :span="5">
                <el-button type="primary" @click="popout = true">新建分类</el-button>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple"></div>
              </el-col>
            </el-form-item>

            <el-form-item label="三级分类">
              <el-col :span="5">
                <el-cascader
                  v-model="formData.three_cate_id"
                  placeholder="选择三级分类"
                  :options="bottomClass"
                  filterable
                  clearable
                ></el-cascader>
              </el-col>
              <el-col :span="5">
                <el-button type="primary" @click="popout = true">新建分类</el-button>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple"></div>
              </el-col>
            </el-form-item>

            <el-form-item label="安全提醒">
              <el-input v-model="formData.notice" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="应对措施">
              <el-input v-model="formData.solutions" type="textarea" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button type="primary" @click="newSubmit" v-if="isBut">提交并新建</el-button>
              <el-button @click="goBack()">取消</el-button>
            </el-form-item>
          </el-form>
          <el-dialog title="创建分类" :visible.sync="popout">
            <el-form ref="formData" :model="formData" label-width="80px">
              <el-form-item label="创建分类">
                <el-cascader
                  v-model="createClassData.parent_cate_id"
                  placeholder="选择创建分类"
                  :options="newCreateClass"
                  filterable
                  clearable
                ></el-cascader>
              </el-form-item>
              <el-form-item label="分类名字">
                <el-input v-model="createClassData.cate_name" placeholder="请输入分类名字"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="createClass">提交</el-button>
                <el-button @click="popout = false">取消</el-button>
              </el-form-item>
            </el-form>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";

export default {
  data() {
    return {
      addressSelectData: null,
      title: "",
      isBut:null,
      editId: undefined,
      formData: {
        one_cate_id: "",
        two_cate_id: "",
        three_cate_id: "",
        notice: "",
        solutions: ""
      },
      isSuccess: false,
      createClassData: {
        //创建分类
        parent_cate_id: "",
        cate_name: ""
      },
      popout: false,
      topClass: [],
      secondaryClass: [],
      bottomClass: [],
      newCreateClass: [
        {
          value: 0,
          label: "新建一级分类"
        },
        {
          value: 1,
          label: "新建二级分类"
        },
        {
          value: 2,
          label: "新建三级分类"
        }
      ]
    };
  },
  created() {
    this.initData();
    if (this.$route.query.editId) {
      this.editId = this.$route.query.editId;
      this.title =  `修改[ ${this.$route.query.name} ]条目`;
      this.isBut = false
    } else {
      this.title = "创建条目";
       this.isBut = true
    }
  },
  methods: {
    initData() {
      this.getClassifyData(0), this.getClassifyData(1), this.getClassifyData(2);
    },

    // 获取分类数据
    getClassifyData(rank) {
      let data = {
        parent_cate_id: rank
      };
      api
        .classifyList(data)
        .then(res => {
          const partys = res.list.map((value, i) => ({
            value: value.id,
            label: value.cate_name
          }));

          if (rank == 0) {
            // 一级分类数据
            this.topClass = partys;
          }

          if (rank == 1) {
            // 二级分类数据
            this.secondaryClass = partys;
          }

          if (rank == 2) {
            // 三级分类数据
            this.bottomClass = partys;
          }
        })
        .catch(err => {});
    },

    // 创建分类
    createClass() {
      let data = {
        parent_cate_id: this.createClassData.parent_cate_id[0],
        cate_name: this.createClassData.cate_name
      };

      api
        .classifyCreate(data)
        .then(res => {
          this.$message({
            message: "创建成功",
            type: "success"
          });
          this.createClassData = {};
          this.popout = false;
          this.test();
        })
        .catch(err => {});
    },

    // 提交并新建
    onSubmit() {
      this.newSubmit();
      if (this.isSuccess) {
        this.goBack();
      }
    },

    //  创建条目
    newSubmit() {
      let data = {
        one_cate_id: this.formData.one_cate_id[0],
        two_cate_id: this.formData.two_cate_id[0],
        three_cate_id: this.formData.three_cate_id[0],
        notice: this.formData.notice,
        solutions: this.formData.solutions
      };
      if (this.editId) {
        
        // 修改数据
        data.id = this.editId;
        api
          .recordedEdit(data)
          .then(res => {
            this.$message({
              message: "修改成功",
              type: "success"
            });
            this.goBack();
          })
          .catch(err => {});
      } else {

        // 创建数据
        api
          .recordedCreate(data)
          .then(res => {
            this.$message({
              message: "创建成功",
              type: "success"
            });
            this.goBack = true;
          })
          .catch(err => {});
      }
    },

    // 返回上级页面
    goBack() {
      this.$router.push({
        name: "responseLibrary"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.line {
  text-align: center;
  color: #8b8b8b;
}
</style>